module.exports = __webpack_public_path__ + "img/Icon3.b626a212.svg";